var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ask-anything-icon",class:`variant-${_vm.variant}`},[_c('img',{attrs:{"src":_vm.src,"alt":"AskAnything Icon"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }